export function createViewPrefsStore(config) {
    const { key, event, defaults, legacyKeys = [] } = config;
    function migrateLegacyPrefs() {
        if (typeof window === "undefined")
            return;
        try {
            const existing = localStorage.getItem(key);
            if (existing)
                return;
            for (const legacyKey of legacyKeys) {
                const legacyValue = localStorage.getItem(legacyKey);
                if (!legacyValue)
                    continue;
                localStorage.setItem(key, legacyValue);
                return;
            }
        }
        catch {
            // ignore storage errors
        }
    }
    function loadViewPrefs() {
        migrateLegacyPrefs();
        try {
            const raw = localStorage.getItem(key);
            if (!raw)
                return defaults;
            const parsed = JSON.parse(raw);
            return { ...defaults, ...parsed };
        }
        catch {
            return defaults;
        }
    }
    function saveViewPrefs(prefs) {
        if (typeof window === "undefined")
            return;
        try {
            localStorage.setItem(key, JSON.stringify(prefs));
            window.dispatchEvent(new CustomEvent(event, { detail: prefs }));
        }
        catch {
            // ignore write errors
        }
    }
    return {
        KEY: key,
        EVT: event,
        DEFAULT_PREFS: defaults,
        loadViewPrefs,
        saveViewPrefs,
    };
}
